export const TOP_BAR = 'TOP_BAR'
